module.exports = __webpack_public_path__ + "assets/img/modal-avatar-7d69b4c6.png";